import PolicyPage from "../../components/PolicyPage";
import { TERMS_CONDITIONS_URL } from "../../constants";

const Terms = () => (
  <PolicyPage title="Terms & Conditions" policyUrl={TERMS_CONDITIONS_URL} />
);

export default Terms;
